const INTENT_IDENTIFIERS = require('./intentIdentifiers');
const SCREEN_NAVIGATION = require('./screenNavigation');
const CORPORATE_ACTION_FORMS = require('./corporateActionForms');

module.exports = {
    INTENT_IDENTIFIERS,
    SCREEN_NAVIGATION,
    CORPORATE_ACTION_FORMS
};